import { Card, CardBody, Col } from "reactstrap";
import CommonFileUpload from "src/CommonElements/CommonFileUpload";
import CommonCardHeader from "../../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { fileUploadData } from "../../../../Data/BonusUi/Dropzone/Dropzone";
import { MultiFileUploads } from "../../../../utils/Constant";

const MultiFileUpload = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={MultiFileUploads} span={fileUploadData} />
        <CardBody>
          <CommonFileUpload multiple />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MultiFileUpload;
